import { mergeStyles } from "@fluentui/react";

export const buttonStackClass = mergeStyles({
  display: "flex",
  flexDirection: "column",
  gap: 8,
  marginTop: 12,
  paddingBottom: 16,
});

export const suggestionButtonClass = mergeStyles({
  justifyContent: "flex-start !important",
  paddingLeft: "24px !important",
  width: "100%",
});
